export const inr = (v) => (v === null || v === undefined || v === '' ? '—' : `${Number(v) < 0 ? '-' : ''}₹${Math.abs(Number(v)).toLocaleString('en-IN', { maximumFractionDigits: 2 })}`);
export const num = (v) => (v === null || v === undefined || v === '' ? '—' : Number(v).toLocaleString('en-IN', { maximumFractionDigits: 3 }));
export const pct = (v) => (v === null || v === undefined || v === '' ? '—' : `${Number(v).toFixed(2)}%`);

const TONES = {
  red: 'bg-rose-50 text-rose-700 border-rose-200',
  amber: 'bg-amber-50 text-amber-700 border-amber-200',
  green: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  blue: 'bg-sky-50 text-sky-700 border-sky-200',
  slate: 'bg-slate-50 text-slate-600 border-slate-200',
  violet: 'bg-indigo-50 text-indigo-700 border-indigo-200',
};

const MAP = {
  Critical: 'red', High: 'amber', Medium: 'blue', Low: 'slate',
  'Fully Received': 'green', 'Partially Received': 'amber', 'Not Received': 'red', 'Excess Received': 'violet',
  'Short Closed': 'slate', 'Unlinked GRN': 'red',
  Increased: 'red', Decreased: 'green', 'No Change': 'slate',
  Matched: 'green', Shortage: 'amber', Excess: 'violet',
  Open: 'red', 'Under Review': 'amber', Resolved: 'green',
  Excellent: 'green', Good: 'blue', Average: 'amber', Poor: 'red', OK: 'green',
  Improved: 'green', Eroded: 'red', Stable: 'slate',
  Active: 'green', Inactive: 'red', Healthy: 'green', Negative: 'red', Zero: 'amber', 'Below Target': 'amber', Missing: 'red',
  Match: 'green', Mismatch: 'red', Different: 'amber', Valid: 'green', Finalized: 'green', Draft: 'slate', Cancelled: 'red',
  Dispatched: 'green', Pending: 'amber', Invoice: 'blue', 'Delivery Challan': 'violet', Yes: 'green', No: 'red',
};

export const toneClass = (v) => TONES[MAP[v] || (v && v !== 'OK' ? 'amber' : 'slate')];

export const dmy = (iso) => (iso && iso.length >= 10 ? `${iso.slice(8, 10)}-${iso.slice(5, 7)}-${iso.slice(0, 4)}` : '—');
export const qtyUnits = (o) => (o && Object.keys(o).length ? Object.entries(o).map(([u, q]) => `${Number(q).toLocaleString('en-IN')} ${u}`).join(' · ') : '—');
